import { Tag, Tooltip } from "@blueprintjs/core";
import moment from "moment";
import { IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { Tooltip2 } from "@blueprintjs/popover2";

import { MailAdminApi, MailLogGridDto } from "../../api";
import { SearchTablePage } from "../../components";
import { useApiService, useTl } from "../../hooks";

import { ETLCodes } from "../../locales";

export interface IMailLogListPageProps {
  requestId: number;
}

export const MailLogListPage: React.FunctionComponent<IMailLogListPageProps> = ({ requestId }) => {
  const api = useApiService(MailAdminApi);
  const { t } = useTl();
  const columns = React.useMemo<IDataTableColumn<MailLogGridDto>[]>(
    () => [
      {
        fieldName: "mailLogId",
      },
      { fieldName: "subject" },
      { fieldName: "to" },
      { fieldName: "cc" },
      { fieldName: "ForceRecipients" },
      {
        fieldName: "attachments",
        alignment: "center",
        headerAlignment: "center",
        render: (o) => {
          const attachmentsSplit = o.attachments.split(",").filter((d) => d !== "");
          const count = attachmentsSplit.length;
          if (count > 0) {
            return (
              <Tooltip2
                content={
                  <div>
                    {attachmentsSplit.map((a, i) => (
                      <div key={i}>{a}</div>
                    ))}
                  </div>
                }
              >
                <Tag style={{ cursor: "pointer" }}>{count}</Tag>
              </Tooltip2>
            );
          }
          return null;
        },
      },
      { fieldName: "sentOn", render: (o) => moment(o.sentOn).format("DD/MM/YYYY HH:mm:ss") },
    ],
    []
  );
  const getCriterias = React.useCallback(() => api.getSearchCriterias(true), [api]);
  const search = React.useCallback(
    (sObj: any) => {
      sObj.requestId = requestId;
      return api.baseSearch(sObj);
    },
    [api, requestId]
  );
  return (
    <SearchTablePage
      columns={columns}
      filterPlaceholder={t(ETLCodes.Filter)}
      getCriteriasFunction={getCriterias}
      searchFunction={search}
      sortKeys={{ sentOn: "DESC" }}
      filterMode="OnEnter"
      withCard={!requestId}
    />
  );
};
